import {
  POST_ACTION_STARTS,
  POST_ACTION_ERRORS,
  GET_ALL_POSTS,
  GET_POST_BY_ID,
  GET_USER_POSTS,
  CREATE_POST,
  UPDATE_POST,
  DELETE_POST,
  PUBLISH_POST,
  ARCHIVE_POST,
} from './actions';

const initialState = {
  posts: [],
  currentPost: null,
  userPosts: [],
  loading: false,
  error: null,
};

const postReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case POST_ACTION_STARTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_ACTION_ERRORS:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_ALL_POSTS:
      return {
        ...state,
        loading: false,
        posts: action.payload,
        error: null,
      };
    case GET_POST_BY_ID:
      return {
        ...state,
        loading: false,
        currentPost: action.payload,
        error: null,
      };
    case GET_USER_POSTS:
      return {
        ...state,
        loading: false,
        userPosts: action.payload,
        error: null,
      };
    case CREATE_POST:
      return {
        ...state,
        loading: false,
        posts: [action.payload, ...state.posts],
        error: null,
      };
    case UPDATE_POST:
      return {
        ...state,
        loading: false,
        posts: state.posts.map((post: any) =>
          post.id === action.payload.id ? action.payload : post
        ),
        currentPost: action.payload,
        error: null,
      };
    case DELETE_POST:
      return {
        ...state,
        loading: false,
        posts: state.posts.filter((post: any) => post.id !== action.payload),
        error: null,
      };
    case PUBLISH_POST:
      return {
        ...state,
        loading: false,
        posts: state.posts.map((post: any) =>
          post.id === action.payload ? { ...post, publish_status: 'PUBLISHED' } : post
        ),
        error: null,
      };
    case ARCHIVE_POST:
      return {
        ...state,
        loading: false,
        posts: state.posts.map((post: any) =>
          post.id === action.payload ? { ...post, publish_status: 'ARCHIVED' } : post
        ),
        error: null,
      };
    default:
      return state;
  }
};

export default postReducer;
